import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

import moment from 'moment-wrapper'
import { useDebouncedFunc } from 'utils/hooks'
import DatetimeInput from 'components/Shared/DatetimeInput/Index'
import FilterTitle from './FilterTitle'

const CHANGE_VALUE_DEBOUNCE_TIMEOUT = 700

const StyledWrapper = styled.div`
  display: flex;
  flex-flow: column;
`

const StyledInputWrapper = styled.div`
  margin: 0 10px 10px 9px;
`

const FilterSectionDate = ({ title, name, onChange, value, userTimeZone }) => {
  let active = !!value
  let initialValue = value ? moment(value).tz(userTimeZone).format() : null
  const momentValue = moment(value)
  active = Boolean(value && momentValue.isValid())
  initialValue = active ? momentValue.tz(userTimeZone).format() : null
  const [value_, setValue_] = useState(initialValue)
  const isEmpty = Boolean(value_ === null)

  useEffect(() => {
    setValue_(initialValue)
  }, [initialValue])

  const onActiveChange = (newActive) => {
    applyChanges(newActive ? value_ : null)
  }

  const onDateChange = (newValue_) => {
    const newValue = !newValue_ ? null : newValue_.tz(userTimeZone).format()
    setValue_(newValue)
    if (active) {
      applyChanges(newValue)
    }
  }
  const onDateChangeWithDelay = useDebouncedFunc(onDateChange, CHANGE_VALUE_DEBOUNCE_TIMEOUT)

  const applyChanges = (newValue) => {
    onChange?.({
      value: newValue,
      name: name,
    })
  }

  return (
    <StyledWrapper data-test={name}>
      <FilterTitle
        disabled={isEmpty}
        active={active}
        title={title}
        onActiveChange={onActiveChange}
      />
      <StyledInputWrapper>
        <DatetimeInput
          value={value_}
          onChange={onDateChangeWithDelay}
          userTimeZone={userTimeZone}
          isPositionFixed
        />
      </StyledInputWrapper>
    </StyledWrapper>
  )
}

FilterSectionDate.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  userTimeZone: PropTypes.string.isRequired,
}

export default FilterSectionDate
